import React, { useEffect } from 'react';
import withStyles from 'react-jss';
import XIcon from './XIcon';

const styles = {
  fillColor: (props) => {
    return {
      color: `${props.tenant.primary}`,
    };
  },
};

function CloseIcon(props) {
  const { onClickParent } = { ...props };

  useEffect(() => {
    document.getElementById('x-icon-brightoutlook-modal').focus();
  }, []);

  return (
    <button
      id="x-icon-brightoutlook-modal"
      className={['close-icon', props.classes.fillColor].join(' ')}
      onClick={(e) => onClickParent(e)}
      onKeyDown={(e) => {
        if (['Enter'].includes(e.key)) onClickParent(e);
      }}
      type="button"
      tabIndex={0}
      aria-label={props.ariaLabel}
    >
      <XIcon color={props.tenant.primary} />
    </button>
  );
}

export default withStyles(styles)(CloseIcon);
